<ng-container *ngIf="(noDetailResults$ | async) === false ; else errorInDetail">
  <app-hotel-detail-desktop
    *ngIf="(isMobile$ | async) === false"
    [hasRappiCard]="hasRappiCard$ | async"
    [isPrime]="isPrime$ | async"
    [isLoggedIn]="isLoggedIn$ | async">
  </app-hotel-detail-desktop>
  <app-hotel-detail-mobile
    *ngIf="isMobile$ | async"
    [headerSticky]="headerSticky"
    [hotelDetailParams]="hotelDetailParams"
    [source]="source"
    [hasRappiCard]="hasRappiCard$ | async"
    [isPrime]="isPrime$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [totalNightsNumber]="totalNightsNumber$ | async"
    (toggleAmenities)="toggleAmenities.emit()"
    (toggleSearch)="toggleSearch.emit()"
    (redirectToSearch)="redirectToSearch.emit()"
    (goToGallery)="goToGallery.emit()">
  </app-hotel-detail-mobile>
</ng-container>

<ng-template #errorInDetail>
  <app-no-results
    [top]="80"
    [error]="errors$ | async">
  </app-no-results>
</ng-template>